// extracted by mini-css-extract-plugin
export default {"breadcrumb":"Page_breadcrumb__xmesx"};